var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculatorHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_887_5471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 28V4.00004C1.33337 2.52728 2.52728 1.33337 4.00004 1.33337H28C29.4728 1.33337 30.6667 2.52728 30.6667 4.00004V28C30.6667 29.4728 29.4728 30.6667 28 30.6667H4.00004C2.52728 30.6667 1.33337 29.4728 1.33337 28Z",
    stroke: "#E11D07",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.33337H22.6667H25.3333",
    stroke: "#E11D07",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20.6666H22.6667H25.3333",
    stroke: "#E11D07",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.6666H22.6667H25.3333",
    stroke: "#E11D07",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 9.33329H9.33329M9.33329 9.33329H12M9.33329 9.33329V6.66663M9.33329 9.33329V12",
    stroke: "#E11D07",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44812 24.5522L9.33373 22.6666M9.33373 22.6666L11.2194 20.781M9.33373 22.6666L7.44812 20.781M9.33373 22.6666L11.2194 24.5522",
    stroke: "#E11D07",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_5471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorHover);
export default __webpack_public_path__ + "static/media/calculatorHover.c9434bcd532fef5618ce57ce1f304ca7.svg";
export { ForwardRef as ReactComponent };